import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { noop } from 'lodash'
import { DisclaimersButton, If } from 'src/Components'
import styles from './AdditionalInfo.module.scss'

const defaultProps = {
  cardWidth: false,
  cardBottom: false,
  showDisclaimers: true,
  visible: false,
}

const propTypes = {
  cardWidth: PropTypes.bool,
  cardBottom: PropTypes.bool,
  showDisclaimers: PropTypes.bool,
  visible: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  targetRef: PropTypes.shape({
    current: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
  }),
}

const AdditionalInfo = ({
  visible,
  children,
  className,
  cardWidth,
  cardBottom,
  showDisclaimers,
  targetRef,
  useExperimentStyles,
  onMouseOver = noop,
}) => {
  const targeted = targetRef !== undefined
  const outerRef = useRef(null)
  const buttonRef =
    targetRef && targetRef.current ? targetRef.current : targetRef

  const tipClass = classnames(styles.content, {
    [styles.open]: visible,
    [styles.cardBottom]: cardBottom,
    [styles.psuedoArrow]: !useExperimentStyles && !targeted,
    [styles.experimentStyles]: useExperimentStyles,
  })

  const additionalInfoClass = classnames(className, {
    [styles.cardWidth]: !useExperimentStyles && cardWidth,
  })

  let left = '0px'
  if (visible && buttonRef && outerRef && outerRef.current) {
    const outerRect = outerRef.current.getBoundingClientRect()
    const targetRect = buttonRef.getBoundingClientRect()

    const outerCenter = outerRect.width / 2 + outerRect.left
    const targetCenter = targetRect.width / 2 + targetRect.left

    left = `${targetCenter - outerCenter}px`
  }

  return (
    <div
      ref={outerRef}
      className={additionalInfoClass}
      onMouseOver={onMouseOver}
    >
      <div className={tipClass}>
        <If condition={!useExperimentStyles && targeted}>
          <span className={styles.arrowBumper} style={{ left }} />
        </If>
        {children}
        <If condition={showDisclaimers}>
          <DisclaimersButton className={styles.button} />
        </If>
      </div>
    </div>
  )
}

AdditionalInfo.defaultProps = defaultProps
AdditionalInfo.propTypes = propTypes

export default AdditionalInfo
